// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__ZMo_A","label":"Category_label__2BOSm","content":"Category_content__1-nOA","header":"Category_header__2jPE9","location":"Category_location__3fF0T"};